export default __webpack_public_path__ + "static/media/mouse.551fed2a.gif";